<template>
    <div class="row mb-5">
        <div class="col-md-6 col-lg-4 d-flex align-items-center mb-2 mb-md-0">{{ fieldText }}</div>
        <div class="col-md-6 col-lg-8">
            <div class="row calc-right-buttons-wrapper">
                <div class="col-lg-6">
                    <label class="calc-radio">
                        <slot name="left"></slot>
                        <span class="checkbox">{{ buttonTextLeft }}</span>	                
                    </label>
                </div>
                <div class="col-lg-6">
                    <label class="calc-radio">
                        <slot name="right"></slot>
                        <span class="checkbox">{{ buttonTextRight }}</span>
                    </label>
                </div>																
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        fieldText: String,
        buttonTextLeft: String,
        buttonTextRight: String
    }
}
</script>